module.exports = __webpack_public_path__ + "img/20220223_160039.9f7efc3c.jpg";